import { useEffect, useState } from 'react'
import { getBooleanFromValue } from 'shared/url'
import { usePersonalizationConfig } from './usePersonalizationConfig'

const PERSONALIZATION_MODAL_QSP = 'personalizationModalOpen'
const UPLOADS_MODAL_QSP = 'uploadsModalOpen'

export type UsePersonalizationModalState = {
  uploadModalOpen: boolean
  setUploadModalOpen: (isOpen: boolean) => void
  mobileModalOpen: boolean
  setMobileModalOpen: (isOpen: boolean) => void
}

export const usePersonalizationModalState = (isInitialized: boolean): UsePersonalizationModalState => {
  const [uploadModalOpen, setUploadModalOpen] = useState(false)
  const [mobileModalOpen, setMobileModalOpen] = useState(false)
  const { isEnabled, mode } = usePersonalizationConfig()

  useEffect(() => {
    const hasUploadModalQSP = getBooleanFromValue(new URLSearchParams(window.location.search).get(UPLOADS_MODAL_QSP))

    const hasMobileModalQSP = getBooleanFromValue(new URLSearchParams(window.location.search).get(PERSONALIZATION_MODAL_QSP))

    if (!isInitialized || !isEnabled) {
      return
    }

    if (hasUploadModalQSP) {
      if (mode === 'modal') {
        setMobileModalOpen(true)
        setUploadModalOpen(true)
      } else if (mode === 'sidebar') {
        setUploadModalOpen(true)
      }
    } else if (hasMobileModalQSP) {
      if (mode === 'modal') {
        setMobileModalOpen(true)
      } else {
        updateParam(PERSONALIZATION_MODAL_QSP, false)
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isInitialized])

  const updateParam = (param: string, value: boolean): void => {
    const url = new URL(window.location.href)
    if (value) {
      url.searchParams.set(param, 'true')
    } else {
      url.searchParams.delete(param)
    }
    window.history.pushState(null, '', url.toString())
  }

  const setUploadModalOpenWithEffect = (isOpen: boolean): void => {
    updateParam(UPLOADS_MODAL_QSP, isOpen)
    setUploadModalOpen(isOpen)
  }

  const setMobileModalOpenWithEffect = (isOpen: boolean): void => {
    if (isOpen) {
      updateParam(UPLOADS_MODAL_QSP, false)
      updateParam(PERSONALIZATION_MODAL_QSP, true)
    } else {
      updateParam(PERSONALIZATION_MODAL_QSP, false)
    }
    setMobileModalOpen(isOpen)
  }

  return {
    uploadModalOpen,
    setUploadModalOpen: setUploadModalOpenWithEffect,
    mobileModalOpen,
    setMobileModalOpen: setMobileModalOpenWithEffect,
  }
}
